var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:[_vm.size],attrs:{"type":_vm.type,"icon":_vm.icon,"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.hotkeys.length)?_c('span',{staticClass:"hotkeys"},[_vm._v(" "+_vm._s(_vm.formattedHotkeys)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }